module.exports = __webpack_public_path__ + "static/media/lactose.b3e880ae.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mm/lactose.svg
// module id = 1125
// module chunks = 0